import { DialogContent, DialogTitle } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { AuditModalTop } from "slot-definitions"

export function AuditModal({
    audit,
    title = "Explain Your Changes",
    field = "revisionSummary",
    label = "Changes Summary",
    placeholder = "",
    okCaption,
    textFieldProps = {},
    ...props
}) {
    return (
        <DataInputDialog initialValue={audit} disableKeys={true} okCaption={okCaption} {...props}>
            <DialogTitle data-cy="audit-modal-title">{title}</DialogTitle>
            <DialogContent>
                <AuditModalTop.Slot />
                <BoundTextField
                    data-cy="audit-modal-text-field"
                    field={field}
                    label={label}
                    margin="normal"
                    multiline
                    minRows={5}
                    maxRows={10}
                    overflow="scroll"
                    autoFocus={true}
                    yup="string.trim.required"
                    placeholder={placeholder}
                    {...textFieldProps}
                />
            </DialogContent>
        </DataInputDialog>
    )
}
